import React from "react";
import SingleSOPExample from "../../components/sop/ExampleUI/SingleSOPExample";
import { useRouter } from "next/router";
import SanityClient from "../../utils/Sanity";
import groq from "groq";
import MetaTags from "../../components/generic/MetaTags";
import Navbar from "../../components/Landing/LandingNavbar";
import Head from "next/head";

const ExamplePage = () => {
  const [data, setData] = React.useState<any>(null);
  const router = useRouter();
  React.useEffect(() => {
    const { exampleId } = router.query;
    const query = groq`*[_type == "sop" && _id == "${exampleId}"]`;
    SanityClient.fetch(query).then((res) => {
      setData(res);
    });
  }, [router.query]);

  const jsonLd = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    name: "Tootler.ai - SOP Templates",
    description:
      "Tootler.ai is a free SOP generator that helps you create professional and polished SOPs in minutes. It's easy to use, and it comes with a variety of features that will make the SOP writing process a breeze. You can also use our plagiarism checker to ensure that your SOPs are original and free of plagiarism. This is important because plagiarism can lead to rejection from schools and employers. Our SOP generator is the perfect tool for anyone who needs to write an SOP. It's easy to use, and it comes with a variety of features that will make the SOP writing process a breeze. Templates provide a starting point for your own SOPs. They are designed to be easy to use and customize, so you can create the perfect SOP for your needs. You can also use our plagiarism checker to ensure that your SOPs are original and free of plagiarism. This is important because plagiarism can lead to rejection from schools and employers. ",

    url: `https://tootler.ai/sop-templates/${router.query.exampleId}`,

    title: `${data?.title}`,
    tags: `${data?.tags}`,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://tootler.ai/sop-templates/${router.query.exampleId}`,
    },
  };

  return (
    <>
      <Head>
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
        <link rel="canonical" href="https://tootler.ai/sop-templates" />
      </Head>
      <main className="font-Inter">
        <MetaTags PageName="SOP Example" />
        <Navbar />
        <SingleSOPExample data={data} />
      </main>
    </>
  );
};

export default ExamplePage;
